import { render, staticRenderFns } from "./sociabilityResult.vue?vue&type=template&id=55a06722&scoped=true&"
import script from "./sociabilityResult.vue?vue&type=script&lang=js&"
export * from "./sociabilityResult.vue?vue&type=script&lang=js&"
import style0 from "./sociabilityResult.vue?vue&type=style&index=0&id=55a06722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a06722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
